import type {
  OrderTableSettingsQueryKey,
  UseOrderTableSettingsParams,
} from '../types';

export const getOrderTableSettingsQueryKey = (
  params: UseOrderTableSettingsParams,
): OrderTableSettingsQueryKey => ['users', params, 'orderTableSettings'];
